import { render, staticRenderFns } from "./CompareHeader.vue?vue&type=template&id=3b634025"
import script from "./CompareHeader.vue?vue&type=script&lang=js"
export * from "./CompareHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports